
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { addProduct, getProductInfo, setProduct } from '@/api/merchant/product'
import { getConst } from '@/api/universal'
import { getProductList } from '@/api/product/product'
import {
  getProductAccountListNoPage,
  newProductAccount,
  getProductAccountList,
  getSettlementTime
} from '@/api/product/productAccount'

import { merchantProductRules } from '@/utils/rules'
import { delObjEmptyKey } from '@/utils'
import { addItem, removeItem } from '@/utils/arrays'
import { isTimeRange } from '@/utils/validate'
import { strToDateArray, timeJoin } from '@/utils/dateTime'
import { getAccountGroupList } from '@/api/product/accountGroup'
import { timeList1, timeList2, paymentCurrency } from '@/utils/constant'
import { getType } from '@/utils/cookies'
import { minTime } from '@/utils/time'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'editProduct',
  components: {}
})
export default class extends Vue {
  // eslint-disable-next-line camelcase
  @Prop({ required: true }) merchant_no!: string
  @Prop({ default: '' }) merchantProductId!: string
  @Prop({ default: [] }) productNameList!: string[]
  private minTime: any = minTime

  get language() {
    return AppModule.language
  }

  private infoForm: any = {
    currency: '',
    product: null,
    product_type: '',
    product_name: '',
    product_account_group: [],
    billing_type: '',
    billing_cycle: '',
    settlement_time: '',
    min_fee: '',
    fixed_fee: '',
    rate: '',
    min_amount: '',
    max_amount: '',
    product_account: [],
    has_diy_billing: 0,
    status: 1,
    open_time: [],
    can_refund: false,
    extra_param: {
      refund_min_fee: '',
      refund_fixed_fee: '',
      refund_rate: '',
      diy_billing: [],
      settlement_time_interval: [],
      product_small_fee_list: [
        {
          fixed_fee: '',
          rate: '',
          min_amount: '',
          max_amount: ''
        }
      ],
      product_utr_query_list: [],
      product_gateway_fee: {
        fixed_fee: ''
      },
      reserve: {
        enabled: false,
        type: '',
        rate: 0,
        retention_cycle: 0,
        retention_cycle_type: ''
      }
    }
  }

  private productFee: any = [
    {
      min_fee: '',
      fixed_fee: '',
      rate: '',
      min_amount: '',
      max_amount: '',
      to_currency: '',
      payment_method: '',
      swift_fee_type: '',
      markup: ''
    }
  ]

  private addFeeItem() {
    this.infoForm.extra_param.product_small_fee_list.push({
      min_amount: '',
      max_amount: '',
      fixed_fee: '',
      rate: ''
    })
  }

  private removeFeeItem(index) {
    this.infoForm.extra_param.product_small_fee_list.splice(index, 1)
  }

  private checkInterval = (rule, value, callback) => {
    // 这里的value是interval
    // 判空
    if (!value.refund_fixed_fee) {
      callback(new Error('Interval cannot be empty.'))
    } else if (!value.refund_min_fee) {
      callback(new Error('Please select refund min fee.'))
    } else if (!value.refund_rate) {
      callback(new Error('Please select refund rate.'))
    } else {
      // 无错 放行
      callback()
    }
  }

  private rules = {
    currency: [
      { required: true, message: 'Please select Currency', trigger: 'blur' }
    ],
    product_type: [
      {
        required: true,
        message: 'Please select product type',
        trigger: 'blur'
      }
    ],
    billing_type: [
      {
        required: true,
        message: 'Please select settlement limit',
        trigger: 'change'
      }
    ],
    fixed_fee: [
      { required: true, message: 'Please select fee', trigger: 'blur' }
    ],
    min_amount: [
      { required: true, message: 'Please select min amount', trigger: 'blur' }
    ],
    product_name: [
      { required: true, message: 'Please select Product', trigger: 'blur' }
    ],

    extra_param: [
      {
        validator: this.checkInterval,
        required: true,
        message: 'Please select refund ree',
        trigger: 'blur'
      }
    ]
  }

  private settlementTime: any = ['00', '00']
  private timeList1 = timeList1
  private timeList2 = timeList2
  private currencyList = paymentCurrency

  private openTimes: any[] = [
    [new Date('2021/01/01 00:00'), new Date('2021/01/01 23:59')]
  ]
  private accountGroupList: any = []
  private merchantProductInfo: any = {}
  private currencyTypes: any[] =
    this.$store.state.app.enterprise.available_currency
  private productList: any[] = []
  private currentProductIndex: any = null
  private productTypes: any[] = []
  private productAccountList: any[] = []
  private page: number = 1
  private isLoad: boolean = true
  private settlementLimit: any[] = ['', '']
  private limitOptions: any[] = [
    {
      value: 'D',
      label: 'D',
      children: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' }
      ]
    },
    {
      value: 'T',
      label: 'T',
      children: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' }
      ]
    },
    {
      value: 'F',
      label: 'F',
      children: [{ value: '0', label: '0' }]
    }
  ]
  private settlementLimitStr: any = []
  private status: any = '1'
  private billingType: any = null
  private billingCycle: any = null

  private isGlobalPay: boolean = true

  private loading = false

  private addItem = addItem
  private removeItem = removeItem

  private settlementTimesAdd = addItem
  private settlementTimesRemove = removeItem

  // 产品类型切换
  private typeChange() {
    this.productAccountList = []
  }

  private selectedValue: any = ''
  private inputValue: any = ''
  private options: any = [
    { label: '选项1', value: 'option1' },
    { label: '选项2', value: 'option2' },
    { label: '选项3', value: 'option3' }
  ]
  private settlement: boolean = false
  private diyBilling: any = []
  private getDefindVal() {
    if (this.infoForm.has_diy_billing === 1) {
      this.diyBilling = this.infoForm.extra_param.diy_billing
    } else {
      if (this.diyBilling.length === 0) {
        this.diyBilling.push({
          billing_type: '',
          billing_cycle: '',
          unit: 'days',
          percent: ''
        })
      }
      if (this.infoForm.extra_param === null) {
        this.infoForm.extra_param = {
          diy_billing: []
        }
      } else {
        this.infoForm.extra_param.diy_billing = []
      }
    }
    this.settlement = true
  }
  private closeSettlement() {
    this.settlement = false
  }
  private flag: boolean = false
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private obj: any = {
    billing_type: '',
    billing_cycle: '',
    unit: 'days',
    percent: ''
  }
  private settlementRate(str) {
    let sum: any = 0
    if (this.diyBilling.length > 0) {
      sum = this.diyBilling.reduce((sum, obj) => (sum += obj.percent - 0), 0)
    }
    if (100 - sum > 0 && str !== '') {
      if (str.target.value !== '') {
        this.diyBilling.push({
          billing_type: '',
          billing_cycle: '',
          unit: 'days',
          percent: 100 - sum
        })
      }
    } else if (str === 'add') {
      this.$message.error('The current percentage is already 100%.')
    }
  }
  // unit单位为hours，展示有效时间
  private isTime: boolean = false
  private isShow: boolean = false
  private addSettlement() {
    let flag: any = this.diyBilling.some(item => {
      return item.billing_type === '' || item.billing_cycle === ''
    })
    if (!flag) {
      let sum = this.diyBilling.reduce(
        (sum, obj) => (sum += obj.percent - 0),
        0
      )
      let time: number = 0
      this.diyBilling.map(item => {
        if (item.unit === 'hours') {
          time += 1
        }
      })
      time === 1 ? (this.isTime = true) : (this.isTime = false)
      this.settlementTime = ['00', '00']
      if (this.diyBilling.length === 1) {
        if (sum === 100) {
          this.settlement = false
          this.infoForm.extra_param.diy_billing = this.diyBilling
          this.infoForm.has_diy_billing = 1
          this.showLimiTime = true
          let arr: any = this.settlementTime
          if (this.infoForm.currency !== '') {
            this.onloadSettlement(
              this.infoForm.has_diy_billing,
              this.infoForm.has_diy_settlement_time === 1
                ? null
                : arr.join(':'),
              this.isTime ? 'hours' : 'days',
              this.diyBilling,
              this.infoForm.has_diy_settlement_time === 1
                ? this.infoForm.extra_param.diy_settlement_time
                : null,
              this.infoForm.has_diy_settlement_time === 1
                ? this.settlementTimeInterval
                : null
            )
          }
        } else {
          this.$message.error('The current percentage is already 100%.')
        }
      } else {
        let btnFlag = this.hasDuplicateIds(this.diyBilling)
        if (btnFlag) {
          let sameArr = this.duplicateItems()
          this.$message.error(`Duplicate configuration: ${sameArr[0]}`)
        } else if (time > 1) {
          this.$message.error(
            `When the settlement period is hourly, only support one settlement rule.`
          )
        } else if (this.diyBilling.length === time || time === 0) {
          if (sum === 100) {
            this.settlement = false
            this.infoForm.extra_param.diy_billing = this.diyBilling
            this.infoForm.has_diy_billing = 1
            this.showLimiTime = true
            let arr: any = this.settlementTime
            if (this.infoForm.currency !== '') {
              this.onloadSettlement(
                this.infoForm.has_diy_billing,
                this.infoForm.has_diy_settlement_time === 1
                  ? null
                  : arr.join(':'),
                this.isTime ? 'hours' : 'days',
                this.diyBilling,
                this.infoForm.has_diy_settlement_time === 1
                  ? this.infoForm.extra_param.diy_settlement_time
                  : null,
                this.infoForm.has_diy_settlement_time === 1
                  ? this.settlementTimeInterval
                  : null
              )
            }
          } else {
            this.$message.error('The current percentage is already 100%.')
          }
        } else {
          this.$message.error(`Time units must be the same.`)
        }
      }
    } else {
      this.isShow = true
    }
  }
  private ids: any = []
  private hasDuplicateIds(val) {
    this.ids = val.map(
      item => item.billing_type + '+' + item.billing_cycle + item.unit
    )
    return new Set(this.ids).size !== this.ids.length
  }
  private duplicateItems() {
    const checkDuplicates = arr => {
      const filtered = arr.filter(
        (item, index, self) => self.indexOf(item) !== index
      )
      return filtered
    }
    return checkDuplicates(this.ids)
  }
  // private addGCashTg() {}
  private removeGCashTg(index: number) {
    this.diyBilling.splice(index, 1)
    if (this.diyBilling === 1) {
      delete this.diyBilling[0].percent
    }
  }
  private backEdit() {
    this.settlement = true
    // this.infoForm.has_diy_billing = 0
    // this.showLimiTime = false
  }
  private deteleDefined() {
    this.infoForm.has_diy_billing = 0
    this.infoForm.billing_type = this.settlementLimit[0]
    this.infoForm.billing_cycle = this.settlementLimit[1]
    if (
      this.infoForm.billing_cycle === '0' ||
      this.infoForm.billing_cycle === 0
    ) {
      this.showLimiTime = false
    } else {
      this.showLimiTime = true
    }
    let arr: any = this.settlementTime
    this.onloadSettlement(
      this.infoForm.has_diy_billing,
      this.infoForm.has_diy_settlement_time === 1 ? null : arr.join(':'),
      'days',
      this.diyBilling,
      this.infoForm.has_diy_settlement_time === 1
        ? this.infoForm.extra_param.diy_settlement_time
        : null,
      this.infoForm.has_diy_settlement_time === 1
        ? this.settlementTimeInterval
        : null
    )
    this.infoForm.extra_param.diy_billing = []
  }
  private error: boolean = false

  private startTimeChange(val) {
    if (this.infoForm.currency !== '') {
      let arr: any = this.settlementTime
      this.onloadSettlement(
        this.infoForm.has_diy_billing,
        arr.join(':'),
        'days',
        this.diyBilling,
        null,
        null
      )
    }
  }
  private endTimeChange(val) {
    if (this.infoForm.currency !== '') {
      let arr: any = this.settlementTime
      this.onloadSettlement(
        this.infoForm.has_diy_billing,
        arr.join(':'),
        'days',
        this.diyBilling,
        null,
        null
      )
    }
  }

  // 监听
  @Watch('infoForm.currency')
  private onCurrencyChange() {
    this.getProductList()
    if (
      this.infoForm.has_diy_billing === 0 ||
      (this.infoForm.has_diy_billing === 1 && this.diyBilling.length > 0)
    ) {
      let time: number = 0
      this.diyBilling.map(item => {
        if (item.unit === 'hours') {
          time += 1
        }
      })
      if (
        time &&
        this.infoForm.product_type !== 'payout' &&
        this.infoForm.product_type !== 'settlement' &&
        this.infoForm.product_type === '' &&
        this.showLimiTime
      ) {
        let arr: any = this.settlementTime
        this.onloadSettlement(
          this.infoForm.has_diy_billing,
          this.infoForm.has_diy_settlement_time === 1 ? null : arr.join(':'),
          time ? 'hours' : 'days',
          this.diyBilling,
          this.infoForm.has_diy_settlement_time === 1
            ? this.infoForm.extra_param.diy_settlement_time
            : null,
          this.infoForm.has_diy_settlement_time === 1
            ? this.settlementTimeInterval
            : null
        )
      }
    }
  }
  @Watch('infoForm.product_type')
  private onProuctTypeChange() {
    this.getProductList()
  }

  // 产品账户列表的重复ID优化
  @Watch('infoForm.product_account')
  private onProductAccount() {
    return Array.from(new Set(this.productAccountList))
  }

  @Watch('infoForm.product_name')
  private onProductName() {
    this.getAccountGroupList()
  }

  // 获取产品列表
  private async getProductList() {
    const data = {
      currency: this.infoForm.currency,
      product_type: this.infoForm.product_type
    }
    await getProductList(data).then((res: any) => {
      this.productList = res.filter((item: any) => {
        return !this.productNameList.includes(item.name)
      })
    })
  }

  // 选择产品
  private async selProductName(index: number) {
    const product = this.productList[index]
    if (
      product.code === 'InternationalTransfer' ||
      product.code === 'FiatPayout'
    ) {
      this.isGlobalPay = false
    } else {
      this.isGlobalPay = true
    }
    this.infoForm.product_name = product.name
    this.infoForm.product = product.id
    this.infoForm.product_account = []
    this.infoForm.product_account_group = []
    this.infoForm.extra_param.product_utr_query_list = []
    this.infoForm.can_refund = product.can_refund
    this.page = 1
    this.isLoad = true
    this.productAccountList = []
    if (this.sysType === 'ant' && this.type === 'normal') {
      await this.getAccountList()
    } else if (this.sysType !== 'ant') {
      await this.getAccountList()
    }
    await this.getAccountGroupList()
  }

  private addFee() {
    this.productFee.push({
      min_fee: '',
      fixed_fee: '',
      rate: '',
      min_amount: '',
      max_amount: '',
      to_currency: '',
      payment_method: '',
      swift_fee_type: '',
      markup: ''
    })
  }

  private remoFee(index: any) {
    if (index > 0) {
      this.productFee.splice(index, 1)
    }
  }

  // 获取产品账户列表
  private async getAccountList() {
    if (!this.isLoad) {
      return false
    } else {
      const data: any = {
        product: this.infoForm.product,
        type: this.type
      }
      await newProductAccount(data).then((res: any) => {
        this.productAccountList = res
        if (res.length > 0) {
          let list = res.filter(
            item => !this.historyList.some(item2 => item2.id === item.id)
          )
          this.productAccountList = [...this.historyList, ...list]
          // this.productAccountList = [...new Set(this.productAccountList)]
        } else {
          this.productAccountList = this.historyList
        }
      })
    }
  }
  private arr: any = []
  private antAccountList: any = []
  private async remoteMethod(query) {
    if (query !== '') {
      const data: any = {
        name: query,
        product: this.infoForm.product,
        type: this.type
      }
      await getProductAccountList(data).then((res: any) => {
        this.antAccountList = res.results.filter(
          item => !this.historyList.some(item2 => item2.id === item.id)
        )
      })
    }
  }
  private changeArr(val) {
    // this.removeArr(val)
    let indexLen: number = val.length
    val.forEach((item, index, arr) => {
      let itemArr: any = item.split(',')
      let obj: any = {}
      obj.id = itemArr[0] - 0
      obj.account_name = itemArr[1]
      obj.state = itemArr[2] - 0
      obj.account_type = itemArr[3]
      if (indexLen - 1 === index) {
        this.productAccountList.push(obj)
      }
    })
    const map = new Map()
    this.productAccountList = this.productAccountList.filter(
      v => !map.has(v.id) && map.set(v.id, 1)
    )
  }
  private itemArr: any = []
  private removeArr(val) {
    this.itemArr = val.split(',')
    this.productAccountList = this.productAccountList.filter(item => {
      return item.id !== this.itemArr[0] - 0
    })
  }

  // 获取账户组列表
  private async getAccountGroupList() {
    const params = {
      product: this.infoForm.product
    }
    await getAccountGroupList(params).then((res: any) => {
      this.accountGroupList = res.results
    })
  }
  private showLimiTime: boolean = false
  private limitChange(value: any) {
    this.infoForm.billing_type = value[0]
    this.infoForm.billing_cycle = value[1]

    if (value[0] === 'D' && value[1] !== '0') {
      console.log(1)
      this.showLimiTime = true
      let arr: any = this.settlementTime
      this.onloadSettlement(
        this.infoForm.has_diy_billing,
        this.infoForm.has_diy_settlement_time === 1 ? null : arr.join(':'),
        'days',
        this.diyBilling,
        this.infoForm.has_diy_settlement_time === 1
          ? this.infoForm.extra_param.diy_settlement_time
          : null,
        this.infoForm.has_diy_settlement_time === 1
          ? this.settlementTimeInterval
          : null
      )
    } else if (value[0] === 'T' && value[1]) {
      console.log(2)
      this.showLimiTime = true
      let arr: any = this.settlementTime
      this.onloadSettlement(
        this.infoForm.has_diy_billing,
        this.infoForm.has_diy_settlement_time === 1 ? null : arr.join(':'),
        'days',
        this.diyBilling,
        this.infoForm.has_diy_settlement_time === 1
          ? this.infoForm.extra_param.diy_settlement_time
          : null,
        this.infoForm.has_diy_settlement_time === 1
          ? this.settlementTimeInterval
          : null
      )
    } else {
      this.showLimiTime = false
    }
  }
  private back() {
    this.$emit('close')
  }
  private submitForm() {
    if (this.error) {
      this.$message.error('The start time cannot be later than the end time.')
    } else {
      ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
        if (valid) {
          try {
            this.loading = true
            if (this.sysType === 'ant' && this.infoForm.settlment_rate === '') {
              this.infoForm.settlment_rate = null
            }
            this.openTimes.forEach((time: any) => {
              if (time[0]) {
                const str = timeJoin(time[0], time[1])
                this.infoForm.open_time.push(str)
              }
            })
            if (
              (this.billingCycle && this.billingCycle !== 0) ||
              this.infoForm.billing_cycle !== '0'
            ) {
              this.infoForm.settlement_time = this.settlementTime.join(':')
            }
            if (
              (this.billingCycle && this.billingCycle === 0) ||
              this.infoForm.billing_cycle === '0'
            ) {
              this.infoForm.settlement_time = '00:00'
            }
            if (this.infoForm.has_diy_billing === 1) {
              delete this.infoForm.billing_cycle
              delete this.infoForm.billing_type
              let time: number = 0
              this.onloadSettlement(
                this.infoForm.has_diy_billing,
                this.infoForm.has_diy_settlement_time === 1
                  ? null
                  : this.infoForm.settlement_time,
                this.isTime ? 'hours' : 'days',
                this.diyBilling,
                this.infoForm.has_diy_settlement_time === 1
                  ? this.infoForm.extra_param.diy_settlement_time
                  : null,
                this.infoForm.has_diy_settlement_time === 1
                  ? this.settlementTimeInterval
                  : null
              )
            }
            if (
              this.infoForm.has_diy_billing === 0 &&
              this.infoForm.product_type !== 'payout' &&
              this.infoForm.product_type !== 'settlement' &&
              (this.infoForm.billing_cycle !== 0 ||
                this.infoForm.billing_cycle !== '0')
            ) {
              this.onloadSettlement(
                this.infoForm.has_diy_billing,
                this.infoForm.has_diy_settlement_time === 1
                  ? null
                  : this.infoForm.settlement_time,
                'days',
                this.diyBilling,
                this.infoForm.has_diy_settlement_time === 1
                  ? this.infoForm.extra_param.diy_settlement_time
                  : null,
                this.infoForm.has_diy_settlement_time === 1
                  ? this.settlementTimeInterval
                  : null
              )
            }
            if (this.productFee.length > 0) {
              this.productFee = this.productFee.filter(
                item => item.payment_method !== ''
              )
            }
            let data: any = {}
            if (this.infoForm.can_refund) {
              if (this.infoForm.extra_param === null) {
                data = {
                  merchant_no: this.merchant_no,
                  ...this.infoForm,
                  status: this.status,
                  extra_param: {
                    product_fee_list: this.productFee,
                    refund_min_fee: this.infoForm.extra_param.refund_min_fee,
                    refund_fixed_fee:
                      this.infoForm.extra_param.refund_fixed_fee,
                    refund_rate: this.infoForm.extra_param.refund_rate,
                    diy_settlement_time:
                      this.infoForm.extra_param.diy_settlement_time,
                    settlement_time_interval: this.settlementTimeInterval,
                    product_gateway_fee:
                      this.infoForm.extra_param.product_gateway_fee,
                    reserve: this.infoForm.extra_param.reserve

                    // diy_billing: this.infoForm.extra_param.diy_billing,
                  }
                }
              } else {
                data = {
                  merchant_no: this.merchant_no,
                  ...this.infoForm,
                  status: this.status,
                  extra_param: {
                    product_fee_list: this.productFee,
                    refund_min_fee: this.infoForm.extra_param.refund_min_fee,
                    refund_fixed_fee:
                      this.infoForm.extra_param.refund_fixed_fee,
                    refund_rate: this.infoForm.extra_param.refund_rate,
                    diy_billing: this.infoForm.extra_param.diy_billing,
                    diy_settlement_time:
                      this.infoForm.extra_param.diy_settlement_time,
                    settlement_time_interval: this.settlementTimeInterval,
                    product_gateway_fee:
                      this.infoForm.extra_param.product_gateway_fee,
                    reserve: this.infoForm.extra_param.reserve
                  }
                }
              }
            } else {
              if (this.infoForm.extra_param === null) {
                data = {
                  merchant_no: this.merchant_no,
                  ...this.infoForm,
                  status: this.status,
                  extra_param: {
                    product_fee_list: this.productFee,
                    diy_settlement_time:
                      this.infoForm.extra_param.diy_settlement_time,
                    product_small_fee_list:
                      this.infoForm.extra_param.product_small_fee_list,
                    settlement_time_interval: this.settlementTimeInterval,
                    product_utr_query_list:
                      this.infoForm.extra_param.product_utr_query_list,
                    product_gateway_fee:
                      this.infoForm.extra_param.product_gateway_fee,
                    reserve: this.infoForm.extra_param.reserve
                  }
                }
              } else {
                data = {
                  merchant_no: this.merchant_no,
                  ...this.infoForm,
                  status: this.status,
                  extra_param: {
                    product_fee_list: this.productFee,
                    diy_billing: this.infoForm.extra_param.diy_billing,
                    diy_settlement_time:
                      this.infoForm.extra_param.diy_settlement_time,
                    product_small_fee_list:
                      this.infoForm.extra_param.product_small_fee_list,
                    settlement_time_interval: this.settlementTimeInterval,
                    product_utr_query_list:
                      this.infoForm.extra_param.product_utr_query_list,
                    product_gateway_fee:
                      this.infoForm.extra_param.product_gateway_fee,
                    reserve: this.infoForm.extra_param.reserve
                  }
                }
              }
            }
            if (!data.extra_param.diy_settlement_time) {
              delete data.extra_param.diy_settlement_time
            }
            if (!data.extra_param.product_utr_query_list) {
              delete data.extra_param.product_utr_query_list
            }
            // 网关手续费未配置时保留字段，fixed_fee 传空字符串
            if (!data.extra_param.product_gateway_fee) {
              data.extra_param.product_gateway_fee = { fixed_fee: '' }
            } else if (!data.extra_param.product_gateway_fee.fixed_fee) {
              data.extra_param.product_gateway_fee.fixed_fee = ''
            }

            if (!this.infoForm.extra_param) {
              delObjEmptyKey(data)
            }

            if (this.isGlobalPay === false) {
              delObjEmptyKey(data)
            }

            if (!data.open_time) {
              data.open_time = []
            }
            delObjEmptyKey(data)
            if (!data.product_account) {
              data.product_account = []
            }
            if (!data.product_account_group) {
              data.product_account_group = []
            }

            if (!this.merchantProductId) {
              await addProduct(data).then((res: any) => {
                this.$message({
                  message: 'Create successful!',
                  type: 'success'
                })
                this.loading = false
                this.back()
              })
            } else {
              await setProduct(data).then((res: any) => {
                this.$message({
                  message: 'Save successful!',
                  type: 'success'
                })
                this.loading = false
                this.back()
              })
            }
            this.infoForm.open_time = []
          } catch (e) {
            this.loading = false
          }
        } else {
          return false
        }
      })
    }
  }

  // 获取产品类型列表
  private async getProductTypes() {
    await getConst('PRODUCT_TYPE_CHOICES').then((res: any) => {
      this.productTypes = res.data
    })
  }

  // 获取商户产品信息
  private sysType: any = ''
  private antProductAccount: any = []
  private async getMerchantProductInfo() {
    try {
      const data: any = {
        merchant_no: this.merchant_no,
        id: this.merchantProductId
      }
      this.productAccountList = []
      await getProductInfo(data).then((res: any) => {
        this.merchantProductInfo = res
        this.infoForm = { ...this.merchantProductInfo }
        if (res.extra_param && res.extra_param.product_fee_list) {
          this.productFee = res.extra_param.product_fee_list
          if (
            this.productFee.length > 0 &&
            (res.product_name === 'InternationalTransfer' ||
              res.product_name === 'FiatPayout')
          ) {
            this.isGlobalPay = false
          } else {
            this.isGlobalPay = true
          }
        }
        this.settlementLimit[0] = res.billing_type
        this.settlementLimit[1] = res.billing_cycle
        this.billingType = res.billing_type
        this.billingCycle = res.billing_cycle
        if (
          (res.billing_type === 'T' || res.billing_type === 'D') &&
          res.billing_cycle !== 0
        ) {
          this.showLimiTime = true
        } else {
          this.showLimiTime = false
        }
        if (res.has_diy_settlement_time) {
          this.infoForm.has_diy_settlement_time = res.has_diy_settlement_time
        } else {
          this.infoForm.has_diy_settlement_time = 0
        }
        // 初始化开放时间段
        const times: any[] = res.open_time
        if (times.length > 0) {
          this.openTimes = []
          times.forEach((time: any) => {
            this.openTimes.push(strToDateArray(time))
          })
          this.infoForm.open_time = []
        }
        if (res.settlement_time) {
          this.settlementTime = res.settlement_time.split(':')
        }
        if (res.has_diy_settlement_time === 1) {
          res.extra_param.diy_settlement_time.map(item => {
            this.diySettlementTime.push(item.split(':'))
          })
        }

        if (
          res.has_diy_settlement_time === 1 &&
          res.extra_param.settlement_time_interval.length > 0
        ) {
          this.settlementTimes = []
          res.extra_param.settlement_time_interval.forEach((item: any) => {
            this.settlementTimes.push(strToDateArray(item))
          })
        }
        let unit: string = ''
        let timeFlag: boolean = false
        if (this.infoForm.has_diy_billing === 1) {
          this.showLimiTime = true
          if (this.infoForm.extra_param.diy_billing) {
            this.diyBilling = this.infoForm.extra_param.diy_billing
            this.diyBilling.map(item => {
              if (item.unit === 'hours') {
                unit = 'hours'
              } else {
                unit = 'days'
              }
              if (item.billing_cycle !== 0) {
                timeFlag = true
              }
            })
          }
        }
        if (
          this.infoForm.product_type !== 'payout' &&
          this.infoForm.product_type !== 'settlement' &&
          (res.billing_cycle !== null || timeFlag)
        ) {
          this.onloadSettlement(
            res.has_diy_billing,
            res.has_diy_settlement_time === 1 ? null : res.settlement_time,
            unit,
            this.diyBilling,
            res.has_diy_settlement_time === 1
              ? res.extra_param.diy_settlement_time
              : null,
            res.has_diy_settlement_time === 1
              ? res.extra_param.settlement_time_interval
              : null
          )
        }

        if (this.sysType !== 'ant') {
          this.getAccountList()
        } else {
          this.productAccountList = res.merchant_product_account
          this.antProductAccount = res.merchant_product_account
          res.merchant_product_account.map((item: any) => {
            let obj = {
              id: item.product_account_id,
              account_name: item.product_account__account_name,
              state: item.product_account__state,
              account_type: item.product_account__account_type
            }
            this.historyList.push(obj)
          })
          if (this.type !== 'ant') {
            this.getAccountList()
          }
        }
        if (this.infoForm.can_refund) {
          if (!this.infoForm.extra_param) {
            this.infoForm.extra_param = {
              refund_min_fee: 0,
              refund_fixed_fee: 0,
              refund_rate: 0
            }
          }
        }
        // 兼容老数据：extra_param 中无网关手续费配置时初始化
        if (this.infoForm.extra_param) {
          if (!this.infoForm.extra_param.product_gateway_fee) {
            this.$set(this.infoForm.extra_param, 'product_gateway_fee', {
              fixed_fee: ''
            })
          }
        }

        if (this.infoForm.extra_param) {
          if (!this.infoForm.extra_param.reserve) {
            this.$set(this.infoForm.extra_param, 'reserve', {
              enabled: false
            })
          }
        }

        if (this.infoForm.extra_param) {
          if (!this.infoForm.extra_param.reserve) {
            this.$set(this.infoForm.extra_param, 'reserve', {
              enabled: false,
              type: '',
              rate: 0,
              retention_cycle: 0,
              retention_cycle_type: ''
            })
          }
        }
      })
    } catch (e) {}
  }
  private historyList: any = []

  private inputText(val) {
    this.$forceUpdate()
  }

  // 获取结算时间
  private nextTime: string = ''
  private settlementTimeInterval: any = []
  private async onloadSettlement(
    isCycle,
    time,
    unit,
    diyBilling,
    diyTime,
    interval
  ) {
    try {
      let data: any = {}
      let settlementTimeInterval: any = []
      this.settlementTimes.forEach((time: any) => {
        if (time[0]) {
          const str = timeJoin(time[0], time[1])
          settlementTimeInterval.push(str)
        }
      })
      // this.settlementTimeInterval = interval ? interval : settlementTimeInterval
      if (diyTime === null && interval === null) {
        this.settlementTimeInterval = null
      } else if (diyTime !== null || interval === null) {
        this.settlementTimeInterval = settlementTimeInterval
      }

      if (isCycle === 1) {
        data = {
          currency: this.infoForm.currency,
          unit: unit,
          settlement_time: time,
          diy_billing: diyBilling,
          diy_settlement_time: diyTime,
          settlement_time_interval: this.settlementTimeInterval
        }
      } else {
        data = {
          currency: this.infoForm.currency,
          unit: 'days',
          settlement_time: time,
          diy_billing: [],
          billing_type: this.settlementLimit[0],
          billing_cycle: this.settlementLimit[1],
          diy_settlement_time: diyTime,
          settlement_time_interval: this.settlementTimeInterval
        }
      }
      await getSettlementTime(data).then((res: any) => {
        this.nextTime = res.next
      })
    } catch (e) {}
  }

  private diyTimeBool: boolean = false
  private diySettlementTime: any = []
  private getDefindTime() {
    if (this.infoForm.has_diy_settlement_time === 1) {
      this.infoForm.extra_param.diy_settlement_time.map(item => {
        this.diySettlementTime.push(item.join(':'))
      })
    } else {
      if (this.diySettlementTime.length === 0) {
        this.diySettlementTime.push(['00', '00'])
      }
      if (this.infoForm.extra_param === null) {
        this.infoForm.extra_param = {
          diy_settlement_time: []
        }
      } else {
        this.infoForm.extra_param.diy_settlement_time = []
      }
    }
    this.diyTimeBool = true
  }
  private removeTime(index: number) {
    this.diySettlementTime.splice(index, 1)
  }
  private addBiyTime() {
    this.diySettlementTime.push(['00', '00'])
    this.settlementTimesAdd(this.settlementTimes)
  }
  private closeBiyTime() {
    this.diyTimeBool = false
  }
  private settlementTimes: any[] = [
    [new Date('2021/01/01 00:00'), new Date('2021/01/01 00:00')]
  ]
  private addBiySave() {
    this.infoForm.extra_param.diy_settlement_time = []
    this.infoForm.has_diy_settlement_time = 1
    this.diySettlementTime.map(item => {
      this.infoForm.extra_param.diy_settlement_time.push(item.join(':'))
    })
    this.onloadSettlement(
      this.infoForm.has_diy_billing,
      null,
      'days',
      this.diyBilling,
      this.infoForm.extra_param.diy_settlement_time,
      this.settlementTimeInterval
    )
    this.closeBiyTime()
  }

  private deteleDiyTime() {
    this.infoForm.has_diy_settlement_time = 0
    this.infoForm.extra_param.diy_settlement_time = []
    let arr: any = this.settlementTime
    this.onloadSettlement(
      this.infoForm.has_diy_billing,
      arr.join(':'),
      'days',
      this.diyBilling,
      null,
      null
    )
  }
  private backDiyTime() {
    this.diyTimeBool = true
  }

  private type: string = 'normal'
  private selProductType() {
    if (this.type === 'ant') {
      this.arr = []
    }
  }

  private init() {
    this.currentProductIndex = null
    this.productAccountList = []
    this.settlementLimit = ['', '']
    this.infoForm = {}
  }
  destroy() {
    this.init()
  }
  mounted() {
    this.sysType = getType()
    if (this.merchantProductId) {
      this.getMerchantProductInfo()
    }
    this.getProductTypes()
    this.getProductList()
  }
}
